import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, ShieldCheck, IndianRupee } from "lucide-react";

const areas = [
  "Kothrud", "Hinjawadi", "Wakad", "Baner", "Pimpri Chinchwad",
  "Pune Railway Station", "Pune Airport", "Aundh", "Kharadi", "Hadapsar",
];

const points = [
  { icon: IndianRupee, title: "Affordable Bike Rental", desc: "Transparent hourly, daily, weekly and monthly bike rental plans with no hidden charges." },
  { icon: ShieldCheck, title: "Self Drive & Verified", desc: "Well-maintained, verified two-wheelers with free helmet and easy online booking." },
  { icon: Clock, title: "Quick Doorstep Pickup", desc: "Instant bike booking with fast pickup — perfect for tourists, students and office commute." },
];

export const AboutPune = () => {
  return (
    <section id="bike-rental-pune" className="relative py-20 sm:py-28 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">Bike Rental in Pune</span>
          <h2 className="mt-3 text-3xl sm:text-5xl font-display font-bold tracking-tight">
            The best bike &amp; scooter rental in Pune
          </h2>
          <p className="mt-5 text-white/70 text-base leading-relaxed">
            Flyzone is your trusted bike rental service in Kothrud, Pune, offering scooters and
            motorcycles on rent for every need. Whether you want a scooter on rent for your daily
            office commute, a self drive bike rental for a weekend trip, or a premium Royal Enfield
            for touring, we have the perfect two wheeler on rent for you.
          </p>
          <p className="mt-4 text-white/70 text-base leading-relaxed">
            From Activa and Access 125 to Bullet, Himalayan and sports bikes, book your bike online
            in minutes and ride away. We're proud to be one of the most affordable and easy bike
            rental options near you in Pune.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {points.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`pune-point-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="rounded-2xl p-6 bg-[#141414] border border-white/10"
            >
              <div className="grid place-items-center w-11 h-11 rounded-xl bg-primary/15 text-primary mb-4">
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-display font-bold">{p.title}</h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-center gap-2 text-white/70 mb-4">
            <MapPin className="w-5 h-5 text-primary" />
            <span className="text-sm font-medium">Popular bike rental locations we serve near you</span>
          </div>
          <div className="flex flex-wrap gap-2.5" data-testid="pune-areas">
            {areas.map((a) => (
              <span
                key={a}
                className="rounded-full border border-white/15 bg-[#141414] px-4 py-1.5 text-sm text-white/70 hover:border-primary/40 hover:text-primary transition-colors"
              >
                Bike Rental in {a}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
